import { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { Button } from '@library/buttons/Button';

import { Prompt } from '../../shared/Prompt';
import { PromptContent } from '../../shared/PromptContent';
import { PromptHeader } from '../../shared/PromptHeader';
import { LoginContext } from './LoginContext';
import { ROUTES } from './constants';

export interface CheckEmailProps {
  email?: string;
}

export const CheckEmail = ({ email: emailProp }: CheckEmailProps) => {
  const history = useHistory();
  const { email } = useContext(LoginContext);
  return (
    <Prompt data-cy="check-email" variant="auth">
      <PromptHeader
        title="Check your email!"
        logoType="icon"
        subtitle={
          <span>
            To sign in, tap the button in the email we sent to
            <span
              style={{
                wordBreak: 'break-all',
                fontWeight: 'bold',
              }}
            >{` ${email || emailProp}`}</span>
            .
          </span>
        }
      />

      <PromptContent>
        <Button isPrimary onClick={() => history.push(ROUTES.LOGIN)}>
          Go back
        </Button>
      </PromptContent>
    </Prompt>
  );
};
